<template>
  <div class="log-container">
    <el-collapse :model="1" @change="handleChange">
      <el-collapse-item  title="操作日志" name="1">
        <ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto; max-height: 250px" v-if="logs.length > 0">
          <li v-for="(item, index) in logs" class="infinite-list-item" :key="index">
            <p class="content">{{ item.content }}</p>
            <span class="time">{{ item.createTime }}</span>
            <el-popover popper-class="log-user" placement="top-start" :title="overview ? overview.name : '该账户没有绑定用户'" width="200" trigger="click">
              <div v-if="overview" class="popover-content">
                <span>工号：{{ overview.staffId || overview.id }}</span>
                <span>手机号：{{ overview.phone }}</span>
                <span>所属部门：{{ overview.departmentName }}</span>
                <span>职位：{{ overview.positionName }}</span>
              </div>
              <span class="user" @click="overviewHandler(item.accountId)" slot="reference">{{ item.userName }}</span>
            </el-popover>
          </li>
        </ul>
        <el-empty v-else description="还没有操作"></el-empty>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getEmployeeOverview } from '@/api/office/employee'
import { getLogs } from '@/api/office/log'

export default {
  props: {
    logInfo: {
      type: Object,
      default: () => null,
    },
    execute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logs: [],
      overview: {},
      overviewCache: [],
    }
  },
  created() {
    if (this.execute) {
      this.initData()
    }
  },
  methods: {
    initData() {
      if (!this.logInfo || !this.logInfo.type) {
        return
      }
      getLogs({ type: this.logInfo.type, linkId: this.logInfo.linkId }).then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.logs = data
        }
      })
    },
    overviewHandler(accountId) {
      const overview = this.overviewCache.find(e => e.accountId === accountId)
      if (overview) {
        this.overview = overview.data
        this.overview.accountId = accountId
        return
      }

      getEmployeeOverview({ accountId }).then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.overviewCache.push({accountId, data})
          this.overview = data
          if (this.overview) {
            this.overview.accountId = accountId
          }
        }
      })
    },
    handleChange(val) {
      if (val && val[0] === '1') {
        this.initData()
      }
    },
  },
}
</script>

<style lang="scss" scope>
.log-container {
  padding: 10px 6px;
}

.el-collapse {
  border-radius: 6px;
  overflow: hidden;
}

.infinite-list {
  margin: 0;
}

.infinite-list-item {
  margin-bottom: 4px;
  span {
    margin-right: 10px;
  }
  .content {
    max-width: 75%;
    margin-bottom: 0px;
  }
  .user {
    color: #409eff;
    cursor: pointer;
  }
  .user,
  .time {
    font-size: 12px;
  }
  .content,
  .time {
    color: #8f8f8f;
  }
  &::marker {
    color: #409eff;
  }
  &:first-child {
    p {
      margin-top: 0;
    }
  }
  &:last-child {
    p {
      margin-bottom: 0;
    }
  }
}

.popover-content {
  display: flex;
  flex-direction: column;
}
</style>

<style lang="scss" scope>
.log-container {
  .el-collapse-item__header {
    padding-left: 20px;
  }
}

.log-user {
  .el-popover__title {
    font-size: 14px;
    padding-bottom: 6px;
    border-bottom: 1px solid #f1f1f1;
  }
  .popover-content {
    font-size: 13px;
    line-height: 1.8;
    opacity: 0.8;
  }
}
</style>

<style lang="scss">
.log-container .el-collapse-item__arrow {
  margin-left: 6px;
}
</style>
